import React from "react";
import LinkListPage from "@/components/institute/LinkListPage";

export default function InstituteAdmissionNotices() {
  return (
    <LinkListPage
      eyebrow="Admissions"
      title="Admission Notices"
      subtitle="Notices and circulars specifically related to admissions — eligibility, cut-offs, schedule, and procedure. Each entry has a name (max 100 characters), an active/inactive status, and either an attached PDF (max 5 MB) or an external link."
      listUrl="/institute/notices?type=admission"
      mutateBaseUrl="/institute/notices"
      extraPayload={{ notice_type: "admission" }}
      testidPrefix="inst-admission-notices"
      itemNoun="Notice"
      uploadKind="inst_notice_pdf"
    />
  );
}
